<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel">
        <div class="flex flex-row">
          <div
            class="fixed-height-content bg-grey-lightest"
            style="width: 320px"
          >
            <div style="position: fixed; width: 320px">
              <div
                class="
                  pannel-out-title pannel-out-title-small
                  m-t-l m-l-l m-r-l
                "
              >
                <h3>Client</h3>
                <div class="pannel-out-option">
                  <a
                    class="btn"
                    href="javascript:void(0);"
                    @click="addCompany"
                    :class="{ active: editOpen == 2 }"
                    >Add Client</a
                  >
                </div>
              </div>
              <div class="m-t m-l-l m-r-l">
                <div class="searchbox m-0">
                  <label for="clientFilter">
                    <i
                      v-if="!filterTxt"
                      class="material-icons-outlined align-middle"
                      style="top: 12px"
                      >search</i
                    >
                    <i
                      v-else
                      @click="filterTxt = ''"
                      class="material-icons-outlined align-middle"
                      style="top: 12px"
                      >clear</i
                    >
                  </label>
                  <input
                    style="width: 222px"
                    id="clientFilter"
                    type="text"
                    @keyup="onQuickFilterChanged"
                    :value="filterTxt"
                    placeholder="Search"
                  />
                </div>
              </div>
              <div
                style="overflow-y: auto; height: calc(100vh - 200px)"
                class="m-t-l"
              >
                <div class="m-l-l m-r-l">
                  <div
                    class="
                      pannel-1 pannel-1-padding
                      m-b
                      relative
                      action-wrapper
                      techStatus
                    "
                    v-for="(item, index) in companiesShowList"
                    :key="index"
                    @click="selectCompany(item)"
                    :class="{
                      'client-active':
                        selectedCompany && selectedCompany.id == item.id,
                    }"
                  >
                    <div class="pannel-1-title">
                      <div style="width: 100%">
                        <h3>
                          <div
                            v-if="!item.url"
                            class="project-company-avatar flex m-r"
                          >
                            <div class="project-company-avatar-container">
                              <span>{{
                                (item.name ? item.name : item.email)
                                  | getFirstLetter
                              }}</span>
                            </div>
                          </div>
                          <img
                            class="m-r"
                            v-else
                            :src="`https://logo.clearbit.com/${item.url}`"
                            style="border-radius: 5px; width: 32px"
                            alt
                          />
                          <div class="flex-1">{{ item.name }}</div>
                        </h3>
                      </div>
                    </div>
                    <div class="hr"></div>
                    <div>
                      <div class="pannel-1-body p-b-0">
                        <p>{{ item.about }}</p>
                      </div>
                      <div class="pannel-1-footer">
                        <div>
                          <span v-if="item.tech_level" class="tech_lvl_tag"
                            ><i class="material-icons align-middle">stream</i
                            >{{ item.tech_level }}</span
                          >
                        </div>
                        <div class="pannel-1-footer-option">
                          <span class="font-color-lighter font-lg">{{
                            item.last_month_amount | currencyFilter("$", 2)
                          }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="fixed-height-content flex-1" v-if="selectedCompany">
            <!--            style="overflow-y: auto; height: calc(100vh - 200px)"-->
            <div
              class="flex flex-row m-t-l m-l-2l justify-content-between"
              style="position: relative; margin-right: 70px; flex-wrap: wrap"
            >
              <div>
                <div class="flex-row flex items-center company-avatar-title">
                  <div
                    v-if="!selectedCompany.url"
                    class="project-company-avatar flex m-r"
                  >
                    <div class="project-company-avatar-container">
                      <span>{{
                        (selectedCompany.name
                          ? selectedCompany.name
                          : selectedCompany.email) | getFirstLetter
                      }}</span>
                    </div>
                  </div>
                  <img
                    class="m-r"
                    v-else
                    :src="`https://logo.clearbit.com/${selectedCompany.url}`"
                    style="border-radius: 5px; width: 52px"
                    alt
                  />
                  <div class="flex-1 font-4lg">{{ selectedCompany.name }}</div>
                </div>
                <div class="company-info">
                  <i class="material-icons align-middle">account_box</i>
                  <strong>Main Contact:</strong>
                  <span class="font-color-base">{{
                    selectedCompany.email ? selectedCompany.email : "none"
                  }}</span>
                </div>
                <div class="company-info">
                  <i class="material-icons align-middle">paid</i>
                  <strong>Billing Contact:</strong>
                  {{
                    selectedCompany.billing_email
                      ? selectedCompany.billing_email
                      : "none"
                  }}
                </div>
                <div class="company-info">
                  <i class="material-icons align-middle">attach_money</i>
                  <strong>Rate:</strong>
                  {{ selectedCompany.rate ? selectedCompany.rate : "none" }}
                </div>
                <div class="company-info flex flex-row">
                  <div>
                    <i class="material-icons align-middle">link</i>
                    <strong>URL:</strong>
                  </div>
                  <div style="line-height: 1.3">
                    <UrlWrapper :url="selectedCompany.url" />
                  </div>
                </div>
                <div class="company-info flex flex-row">
                  <div>
                    <i class="material-icons align-middle">info</i>
                    <strong>ABOUT:</strong>
                  </div>
                  <div style="line-height: 1.3">
                    {{ selectedCompany.about ? selectedCompany.about : "none" }}
                  </div>
                </div>
              </div>
              <div>
                <div class="statistics flex flex-row justify-end">
                  <div>
                    <h6>Hours Used:</h6>
                    <p>
                      {{
                        selectedCompany.totalHours
                          ? selectedCompany.totalHours
                          : 0
                      }}
                    </p>
                  </div>
                  <div style="width: 120px">
                    <h6>Account Revenue:</h6>
                    <p>
                      {{
                        selectedCompany.total_amount
                          ? selectedCompany.total_amount
                          : 0 | currencyFilter("$", 2)
                      }}
                    </p>
                  </div>
                </div>
                <div class="statistics flex flex-row justify-end">
                  <div>
                    <h6>Projects:</h6>
                    <p>
                      {{ projectRowData ? projectRowData.length : 0 }}
                    </p>
                  </div>
                  <div style="width: 120px">
                    <h6>Month Active:</h6>
                    <p>
                      {{
                        selectedCompany.monthActive
                          ? selectedCompany.monthActive
                          : 0
                      }}
                    </p>
                  </div>
                </div>
                <div class="statistics flex flex-row justify-end">
                  <div>
                    <h6>Revenue Last Month:</h6>
                    <p>
                      {{
                        selectedCompany.last_month_amount
                          ? selectedCompany.last_month_amount
                          : 0 | currencyFilter("$", 2)
                      }}
                    </p>
                  </div>
                </div>
              </div>
              <div
                style="position: absolute; right: -40px; top: 10px"
                ref="dropdown"
              >
                <span
                  class="header-pannelclose menu-button"
                  @click="toggleDropdown"
                >
                  <i class="material-icons align-middle">more_horiz</i>
                </span>
                <div v-if="showDropdown" class="dropdown-wrapper">
                  <Dropdown @dropdownClick="dropdownClick" />
                </div>
              </div>
            </div>

            <div class="tab-nav">
              <ul>
                <li :class="{ active: tabNave === 1 }" @click="tabNave = 1">
                  Payment Data
                </li>
                <li :class="{ active: tabNave === 2 }" @click="tabNave = 2">
                  Invoices
                </li>
                <li :class="{ active: tabNave === 3 }" @click="tabNave = 3">
                  Work Log
                </li>
                <li :class="{ active: tabNave === 4 }" @click="tabNave = 4">
                  User
                </li>
                <li :class="{ active: tabNave === 5 }" @click="tabNave = 5">
                  Projects
                </li>
              </ul>
            </div>
            <div class="bg-white p-b">
              <div class="account-grid" v-show="tabNave === 1">
                <ag-grid-vue
                  style="width: 100%; height: 450px"
                  class="ag-theme-material"
                  :gridOptions="paymentGridOptions"
                  :columnDefs="paymentColumnDefs"
                  @column-resized="onColumnResized"
                  @first-data-rendered="onFirstDataRendered"
                  @grid-size-changed="onFirstDataRendered"
                  :rowData="paymentRowData"
                ></ag-grid-vue>
              </div>
              <div class="account-grid" v-show="tabNave === 2">
                <ag-grid-vue
                  style="width: 100%; height: 450px"
                  class="ag-theme-material"
                  :gridOptions="invoiceGridOptions"
                  :columnDefs="invoiceColumnDefs"
                  @column-resized="onColumnResized"
                  @first-data-rendered="onFirstDataRendered"
                  @grid-size-changed="onFirstDataRendered"
                  :rowData="invoiceRowData"
                ></ag-grid-vue>
              </div>
              <div class="account-grid" v-show="tabNave === 3">
                <ag-grid-vue
                  style="width: 100%; height: 450px"
                  class="ag-theme-material"
                  :gridOptions="checkinGridOptions"
                  :columnDefs="checkinColumnDefs"
                  @column-resized="onColumnResized"
                  @first-data-rendered="onFirstDataRendered"
                  @grid-size-changed="onFirstDataRendered"
                  :rowData="checkinRowData"
                ></ag-grid-vue>
              </div>
              <div class="account-grid" v-show="tabNave === 4">
                <ag-grid-vue
                  style="width: 100%; height: 450px"
                  class="ag-theme-material"
                  :gridOptions="clientGridOptions"
                  :columnDefs="clientColumnDefs"
                  @column-resized="onColumnResized"
                  @first-data-rendered="onFirstDataRendered"
                  @grid-size-changed="onFirstDataRendered"
                  :rowData="clientRowData"
                ></ag-grid-vue>
              </div>
              <div class="account-grid" v-show="tabNave === 5">
                <ag-grid-vue
                  style="width: 100%; height: 300px"
                  class="ag-theme-material"
                  :gridOptions="projectGridOptions"
                  :columnDefs="projectColumnDefs"
                  @column-resized="onColumnResized"
                  @first-data-rendered="onFirstDataRendered"
                  @grid-size-changed="onFirstDataRendered"
                  :rowData="projectRowData"
                ></ag-grid-vue>
              </div>
            </div>
          </div>
        </div>
      </div>

      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelCompanyInvoice
            v-if="editOpen == 1"
            :submitLoading="companyInvoiceSubmitLoading"
            @buttonClick="onInvoiceButtonClick"
            @closePanel="closeEditPannel"
          ></PanelCompanyInvoice>
          <PanelCompany
            v-if="editOpen == 2 || editOpen == 3"
            :propsData="editData"
            :submitLoading="companySubmitLoading"
            @buttonClick="onCompanyButtonClick"
            @closePanel="closeEditPannel"
          ></PanelCompany>
          <PanelCompanyUser
            v-if="editOpen == 4"
            :submitLoading="companyUserSubmitLoading"
            @buttonClick="onUserButtonClick"
            @closePanel="closeEditPannel"
          ></PanelCompanyUser>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import EditPannel from "@/components/EditPannel.vue";
import OptionMenu from "@/components/OptionMenu.vue";
import { db } from "@/vendor/firebase";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import * as utils from "@/utils/utils";
import { httpGet } from "@/http/http";
import moment from "moment";
import PanelCompany from "@/components/admin/companyAdmin/PanelCompany.vue";
import PanelCompanyInvoice from "@/components/admin/companyAdmin/PanelCompanyInvoice.vue";
import PanelCompanyUser from "@/components/admin/companyAdmin/PanelCompanyUser.vue";
import GridViewAs from "@/components/admin/companyAdmin/GridViewAs.vue";
import GridInvoiceLink from "@/components/admin/companyAdmin/GridInvoiceLink.vue";
import { dateformat } from "@/utils/utils";
import Dropdown from "@/components/admin/companyAdmin/Dropdown.vue";
import UrlWrapper from "@/components/UrlWrapper.vue";

export default {
  props: ["editOpenTitle"],
  data() {
    return {
      filterTxt: "",
      companies: null,
      // consultants: null,
      jobs: null,
      clients: null,
      company_users: null,
      projects: null,

      selectedCompany: null,
      editData: null,
      editOpen: false,

      checkinGridOptions: null,
      invoiceGridOptions: null,
      paymentGridOptions: null,
      clientGridOptions: null,
      projectGridOptions: null,
      checkinColumnDefs: null,
      invoiceColumnDefs: null,
      paymentColumnDefs: null,
      clientColumnDefs: null,
      projectColumnDefs: null,
      checkinRowData: null,
      invoiceRowData: null,
      paymentRowData: null,
      clientRowData: null,
      projectRowData: null,

      companySubmitLoading: false,
      companyInvoiceSubmitLoading: false,
      companyUserSubmitLoading: false,

      tabNave: 1,

      showDropdown: false,
    };
  },
  components: {
    EditPannel,
    OptionMenu,
    AgGridVue,
    PanelCompanyInvoice,
    PanelCompany,
    PanelCompanyUser,
    GridViewAs,
    GridInvoiceLink,
    Dropdown,
    UrlWrapper,
  },
  watch: {
    editOpenTitle: function (val) {
      this.editOpen = val;
    },
    companies: function (val) {
      if (val && !!val[0] && !!val[0].id) {
        if (!this.selectedCompany) {
          this.selectCompany(
            val.reduce((p, c) =>
              (p.last_month_amount ? p.last_month_amount : 0) >
              (c.last_month_amount ? c.last_month_amount : 0)
                ? p
                : c
            )
          );
        } else {
          this.createCheckinRowData();
          this.createClientRowData();
        }
      }
    },
    jobs: function () {
      this.createCheckinRowData();
      this.createClientRowData();
    },
    clients: function () {
      this.createCheckinRowData();
      this.createClientRowData();
    },
    company_users: function () {
      this.createClientRowData();
    },
    projects: function () {
      this.createProjectRowData();
    },
    selectedCompany: function () {
      this.createCheckinRowData();
      this.createClientRowData();
      this.createPaymentRowData();
      this.createInvoiceRowData();
      this.createProjectRowData();
    },
    tabNave: function () {
      this.createCheckinRowData();
      this.createClientRowData();
      this.createPaymentRowData();
      this.createInvoiceRowData();
      this.createProjectRowData();
    },
  },
  computed: {
    companiesShowList: function () {
      let list = [];
      if (this.filterTxt) {
        const lowerFilterTxt = this.filterTxt.toLowerCase();
        list = (this.companies || []).filter(
          (item) =>
            JSON.stringify(item).toLowerCase().indexOf(lowerFilterTxt) >= 0
        );
      } else {
        list = this.companies;
      }
      list.sort(
        (a, b) =>
          (b.last_month_amount ? b.last_month_amount : 0) -
          (a.last_month_amount ? a.last_month_amount : 0)
      );
      return list;
    },
  },
  beforeMount() {
    this.bindData();
    this.createColumnDefs();
  },
  created: function () {
    this.$EventBus.$on("globalClick", (event) => {
      if (this.$refs.dropdown?.contains(event.target)) {
        // this.showDropdown = false;
      } else {
        this.showDropdown = false;
      }
    });
  },
  methods: {
    bindData: function () {
      this.$bind("companies", db.collection("companies"));
      // this.$bind("consultants", db.collection("consultants"));
      this.$bind("jobs", db.collection("jobs").orderBy("check_in", "desc"));
      this.$bind("clients", db.collection("clients"));
      this.$bind("company_users", db.collection("company_users"));
      this.$bind("projects", db.collection("gigs"));
    },
    toggleDropdown: function () {
      this.showDropdown = !this.showDropdown;
    },
    onQuickFilterChanged: function (event) {
      this.filterTxt = event.target.value;
    },
    onColumnResized: function (params) {
      params.api.resetRowHeights();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    createColumnDefs: function () {
      this.checkinGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.invoiceGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.paymentGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.clientGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.projectGridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true,
        },
        animateRows: true,
        enableCellTextSelection: true,
      };
      this.checkinColumnDefs = [
        {
          headerName: "CHECKIN",
          field: "checkinDate",
          comparator: utils.dateComparator,
          sort: "desc",
          sortingOrder: ["desc", "asc"],
        },
        { headerName: "CONSULTANT", field: "name" },
        { headerName: "SUMMARY", field: "summary", cellClass: "word-wrap" },
        {
          headerName: "HOURS",
          field: "hours",
          sortingOrder: ["desc", "asc"],
        },
      ];
      this.invoiceColumnDefs = [
        { headerName: "CREATED", field: "createdString" },
        { headerName: "TOTAL", field: "total" },
        { headerName: "STATUS", field: "status" },
        {
          headerName: "LINK",
          field: "url",
          cellRendererFramework: "GridInvoiceLink",
        },
        { headerName: "ID", field: "id" },
      ];
      this.paymentColumnDefs = [
        { headerName: "CREATED", field: "created" },
        { headerName: "AMOUNT", field: "amount" },
        {
          headerName: "DESCRIPTION",
          field: "description",
          cellClass: "word-wrap",
        },
        { headerName: "STATUS", field: "status" },
        { headerName: "ID", field: "id" },
      ];
      this.clientColumnDefs = [
        { headerName: "EMAIL", field: "email" },
        { headerName: "NAME", field: "name" },
        { headerName: "HOURS", field: "hours" },
        { headerName: "CHANNEL", field: "channel_id" },
        {
          headerName: "VIEW AS",
          field: "view",
          cellRendererFramework: "GridViewAs",
          sortable: false,
          filter: false,
          rowGroup: false,
        },
      ];
      this.projectColumnDefs = [
        { headerName: "CREATED TIME", field: "createdTime" },
        { headerName: "TITLE", field: "title" },
        { headerName: "LOCATION", field: "location" },
        { headerName: "HOURS PER WEEK", field: "hours_per_week" },
        { headerName: "WORK TYPE", field: "work_type" },
        { headerName: "ENGAGEMENT LENGTH", field: "engagement" },
        { headerName: "ESTIMATED START", field: "estimatedStart" },
      ];
    },
    selectCompany: function (item) {
      if (item) {
        if (this.editOpen == 3) {
          this.closeEditPannel();
        }
        this.selectedCompany = item;
      }
    },
    addCompany: function () {
      this.editData = {
        type: "add",
      };
      this.openEditPannel(2, "Add Company", true);
    },
    editCompany: function () {
      this.editData = {
        ...this.selectedCompany,
        type: "edit",
      };
      this.openEditPannel(3, "Edit Company", true);
    },
    deleteCompany: function () {
      utils.deleteConfirm(() => {
        db.collection("companies")
          .doc(this.selectedCompany.id)
          .delete()
          .then(() => {
            this.$toasted.global.toast_success({ message: "delete success" });
            this.selectCompany(this.companies[0]);
          })
          .catch((error) => {
            this.$toasted.global.toast_error({ message: error });
          });
      });
    },
    onCompanyButtonClick: function (data) {
      this.companySubmitLoading = true;
      if (data.type == "add") {
        this.onAddCompany(data);
      } else if (data.type == "edit") {
        this.onEditCompany(data);
      }
    },
    onAddCompany: function (data) {
      const addDate = {
        name: data.name ? data.name : null,
        email: data.email ? data.email : null,
        billing_email: data.billingEmail ? data.billingEmail : null,
        rate: data.rate ? utils.toNumber(data.rate) : null,
        is_active: data.isActive ? true : false,
        about: data.about ? data.about : null,
        stripe_id: data.stripeId ? data.stripeId : null,
        signed: data.signed ? data.signed : false,
        url: data.url ? data.url : null,
      };
      db.collection("companies")
        .add(addDate)
        .then((docRef) => {
          const companyId = docRef.id;
          db.collection("gigs").add({
            company: companyId,
            created: moment().valueOf() / 1000,
            title: `${data.name} default project`,
          });
          this.closeEditPannel();
          this.$toasted.global.toast_success({
            message: "add success",
          });
        })
        .catch((error) => {
          this.$toasted.global.toast_error({ message: error });
        })
        .finally(() => {
          this.companySubmitLoading = false;
        });
    },
    onEditCompany: function (data) {
      const editData = {
        name: data.name ? data.name : null,
        email: data.email ? data.email : null,
        billing_email: data.billingEmail ? data.billingEmail : null,
        rate: data.rate ? utils.toNumber(data.rate) : null,
        is_active: data.isActive ? true : false,
        about: data.about ? data.about : null,
        stripe_id: data.stripeId ? data.stripeId : null,
        signed: data.signed ? data.signed : false,
        url: data.url ? data.url : null,
      };
      db.collection("companies")
        .doc(this.selectedCompany.id)
        .update(editData)
        .then((docRef) => {
          this.closeEditPannel();
          this.$toasted.global.toast_success({
            message: "edit success",
          });
          this.selectedCompany = {
            ...this.selectedCompany,
            ...editData,
            id: this.selectedCompany.id,
          };
        })
        .catch((error) => {
          this.$toasted.global.toast_error({ message: error });
        })
        .finally(() => {
          this.companySubmitLoading = false;
        });
    },
    onInvoiceButtonClick: function (item) {
      const companyId = this.selectedCompany.id;
      if (companyId) {
        this.companyInvoiceSubmitLoading = true;
        httpGet("create_invoice", {
          companyId,
          startTime: item.startTime,
          endTime: item.endTime,
          isFinalized: item.isFinalized,
        })
          .then((response) => {
            if (response.ok) {
              this.$toasted.global.toast_success({
                message: "create success",
              });
              this.closeEditPannel();
            } else {
              this.$toasted.global.toast_error({
                message: response.message || "create error",
              });
            }
          })
          .finally(() => {
            this.companyInvoiceSubmitLoading = false;
          });
      }
    },
    createCheckinRowData: function () {
      if (this.tabNave !== 3) return;
      if (this.selectedCompany) {
        const checkinRowData = utils.queryArray(
          this.jobs,
          this.selectedCompany.id,
          "company"
        );
        // this.selectedCompany.consultantCount = 0;
        // const consultants = {};
        let totalHours = 0;
        let firstCheckin = null;
        checkinRowData.forEach((item, index) => {
          const hours = utils.workHours(
            item.check_out - item.check_in,
            item.work_type
          );
          item.hours = hours;
          totalHours += hours;
          item.checkinDate = utils.dateformat(
            item.check_in,
            "MM/DD/YYYY HH:mm A"
          );
          // let consultant = utils.queryArray(
          //   this.consultants,
          //   item.consultant,
          //   "email"
          // );
          item.name = item.consultant;
          // item.name = consultant.length ? consultant[0].name : null;
          // if (!consultants[item.consultant]) {
          //   consultants[item.consultant] = true;
          //   this.selectedCompany.consultantCount += 1;
          // }
          if (
            (!firstCheckin && item.check_in) ||
            (firstCheckin && firstCheckin > item.check_in)
          ) {
            firstCheckin = item.check_in;
          }
        });
        if (firstCheckin) {
          const monthActive =
            moment().diff(moment(firstCheckin * 1000), "months") + 1;
          this.selectedCompany.monthActive = monthActive;
        } else {
          this.selectedCompany.monthActive = 0;
        }
        this.selectedCompany.totalHours = utils.fixHours(totalHours);
        this.checkinRowData = checkinRowData;
      }
    },
    createClientRowData: function () {
      if (this.tabNave !== 4) return;
      if (this.selectedCompany) {
        const clientRowData = utils.queryArray(
          this.clients,
          this.selectedCompany.id,
          "company"
        );
        const companyUsers = utils.queryArray(
          this.company_users,
          this.selectedCompany.id,
          "company"
        );
        const companyJobs = utils.queryArray(
          this.jobs,
          this.selectedCompany.id,
          "company"
        );
        clientRowData.forEach((item, index) => {
          item.company_id = this.selectedCompany.id;
          const fullName = utils.getFullName(item.firstName, item.lastName);
          item.name = fullName ? fullName : null;
          item.company_name = this.selectedCompany.name;
          const jobs = utils.queryArray(
            companyJobs,
            item.channel_id,
            "channel_id"
          );
          item.hours = 0;
          for (const i in jobs) {
            const hours = utils.workHours(
              jobs[i].check_out - jobs[i].check_in,
              jobs[i].work_type
            );
            item.hours += hours;
          }
          item.hours = utils.fixHours(item.hours);
        });
        companyUsers.forEach((item, index) => {
          item.company_id = this.selectedCompany.id;
          item.company_name = this.selectedCompany.name;
        });
        this.clientRowData = clientRowData.concat(companyUsers);
      }
    },
    createPaymentRowData: function () {
      if (this.tabNave !== 1) return;
      this.paymentRowData = [];
      const stripeId = this.selectedCompany.stripe_id;
      if (stripeId) {
        httpGet("get_payment_by_stripe_id", {
          stripeId,
        }).then((response) => {
          if (response.ok) {
            const paymentData = response.data;
            paymentData.sort((a, b) => b.created - a.created);
            paymentData.forEach((item) => {
              item.created = utils.dateformat(
                item.created,
                "MM/DD/YYYY HH:mm A"
              );
              item.amount = "$" + (item.amount / 100).toFixed(2);
            });
            if (this.selectedCompany.stripe_id == stripeId) {
              this.paymentRowData = paymentData;
              this.$forceUpdate();
            }
          } else {
            // console.log(response.message);
          }
        });
      }
    },
    createInvoiceRowData: function () {
      if (this.tabNave !== 2) return;
      this.invoiceRowData = [];
      const stripeId = this.selectedCompany.stripe_id;
      if (stripeId) {
        httpGet("get_invoice", { stripeId }).then((response) => {
          if (response.ok) {
            const invoiceData = response.data;
            invoiceData.sort((a, b) => b.created - a.created);
            invoiceData.forEach((item) => {
              item.total = "$" + (item.total / 100).toFixed(2);
              item.createdString = moment(item.created * 1000).format(
                "MM/DD/YYYY HH:mm A"
              );
            });
            if (this.selectedCompany.stripe_id == stripeId) {
              this.invoiceRowData = invoiceData;
            }
          }
        });
      }
    },
    createProjectRowData: function () {
      if (this.tabNave !== 5) return;
      this.projectRowData = this.projects
        .filter((item) => item.company === this.selectedCompany?.id)
        .map((item) => ({
          ...item,
          createdTime: dateformat(item.created, "MM/DD/YYYY"),
          estimatedStart: dateformat(item.estimated_start, "MM/DD/YYYY"),
        }));
    },
    openEditPannel: function (action, title, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        this.emitEditPannel(title);
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
      this.emitEditPannel(title);
    },
    closeEditPannel: function () {
      this.editOpen = false;
      this.emitEditPannel();
    },
    emitEditPannel: function (title) {
      const param = {
        title: title,
        editOpen: this.editOpen,
      };
      this.$emit("openEditPannelTitle", param);
    },
    onUserButtonClick: function (email, password, sendEmail) {
      const companyId = this.selectedCompany.id;
      this.companyUserSubmitLoading = true;
      httpGet("add_company_user", {
        company: companyId,
        email: email,
        password: password,
        sendEmail: sendEmail,
      })
        .then((response) => {
          if (response.ok) {
            this.$toasted.global.toast_success({ message: "add success" });
            this.closeEditPannel();
          } else {
            this.$toasted.global.toast_success({ message: "add error" });
          }
        })
        .finally(() => {
          this.companyUserSubmitLoading = false;
        });
    },
    dropdownClick: function (data) {
      this.showDropdown = false;
      switch (data) {
        case "add":
          this.openEditPannel(4, "Add User", false);
          return;
        case "create":
          this.openEditPannel(1, "Create Invoice", false);
          return;
        case "edit":
          this.editCompany();
          return;
        case "delete":
          this.deleteCompany();
          return;
      }
      console.log("dropdownClick", data);
    },
  },
};
</script>

<style lang="scss" scoped>
.company-avatar-title {
  margin-bottom: 20px;
  .project-company-avatar {
    width: 50px;
    .project-company-avatar-container {
      width: 50px;
      height: 50px;
      span {
        line-height: 42px;
        font-size: var(--font-size-3l);
      }
    }
  }
}
.company-info {
  margin-bottom: 20px;
  color: var(--font-color-lighter);
  [class^="material-icons"] {
    font-size: var(--font-size-2l);
    margin-right: var(--margin);
    margin-top: -5px;
    color: var(--font-color-lighter);
  }
  strong {
    font-size: var(--font-size-2l);
    font-weight: 500;
    margin-right: 16px;
    color: var(--font-color-base);
  }
}

.statistics {
  div {
    text-align: right;
    margin-right: var(--margin-2l);
    margin-bottom: var(--margin-2l);
    h6 {
      padding: 0;
      margin: 0;
      font-size: var(--font-size-l);
      color: var(--font-color-lighter);
      white-space: nowrap;
      margin-bottom: var(--margin);
    }
    p {
      padding: 0;
      margin: 0;
      font-size: var(--font-size-2l);
      font-weight: 700;
    }
  }
}
.client-active {
  border: 2px solid #0085ff;
  box-sizing: border-box;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.1), 0px 3px 3px rgba(0, 0, 0, 0.06),
    0px 3px 4px rgba(0, 0, 0, 0.08);
}
.menu-button {
  cursor: pointer;
}
.dropdown-wrapper {
  position: absolute;
  right: 0;
  top: 24px;
}
</style>
